import { siteInfo } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center pt-20 md:pt-24 pb-12 md:pb-16 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20background%20with%20warm%20red%20and%20amber%20gradients%2C%20soft%20organic%20shapes%2C%20no%20text%2C%20no%20people%2C%20moody%20atmospheric%20lighting%2C%20cinematic%20composition%2C%20subtle%20grain%20texture%2C%20warm%20dark%20tones&width=1800&height=900&seq=hero-bg-2025-x1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-sm font-medium mb-5">
              <i className="ri-flashlight-line text-base"></i>
              {siteInfo.tagline}
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              {siteInfo.name}
              <span className="block text-primary-400 mt-1">网红圈吃瓜第一站</span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-background-300 font-heading">
              {siteInfo.slogan}
            </p>

            <p className="mt-6 text-sm md:text-base text-background-300/80 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-7">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                开始吃瓜
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20of%20a%20breaking%20news%20concept%2C%20red%20spotlight%20on%20a%20newspaper%20folded%20on%20dark%20desk%2C%20warm%20amber%20accents%2C%20investigative%20journalism%20vibe%2C%20cinematic%20lighting%2C%20moody%20atmosphere%2C%20high%20contrast%2C%20film%20grain%20texture%2C%20no%20people&width=900&height=675&seq=hero-visual-2025-x1&orientation=landscape"
                alt="每日爆料主题视觉"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 rounded-lg border border-background-50/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}